export class TableElement<T> {
    id: number;
    currentData: T;
    originalData?: T;

    constructor(init: Partial<TableElement<T>>) {
        Object.assign(this, init);
    }
}
